// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2VV21","title":"AfterFrontImage_title__1hhJx"};